import getLocaleUrlFromNodeLocale from './getLocaleUrlFromNodeLocale';
import {Locale} from '../RootProvider/LocaleContext';
import {FormatMessageFunction, ObjectOfAny} from '../types';

interface Params {
  formatMessage: FormatMessageFunction;
  locale: Locale;
}

const getCorporationSEOSchema = ({formatMessage, locale}: Params): ObjectOfAny => {
  return {
    '@context': 'https://schema.org',
    '@type': 'Corporation',
    name: 'Funding Options',
    url: `https://www.fundingoptions.com${getLocaleUrlFromNodeLocale(locale)}`,
    logo: 'https://www.fundingoptions.com/static/common/images/funding-options-logo-white.svg',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: `${formatMessage({id: 'phoenix.contact.phoneNumber.withCountryCode'})}`,
      contactType: 'customer service',
      areaServed: 'GB',
      availableLanguage: 'en',
    },
    sameAs: [
      'https://www.facebook.com/fundingoptionsuk',
      'https://twitter.com/FundingOptions',
      'https://www.instagram.com/fundingoptionsuk/',
      'https://www.linkedin.com/company/funding-options/',
    ],
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: `${formatMessage({id: 'seo.aggregateRating.ratingValue'})}`,
      bestRating: '5',
      worstRating: '0',
      reviewCount: `${formatMessage({id: 'seo.aggregateRating.reviewCount'})}`,
    },
  };
};

export default getCorporationSEOSchema;
